import admin from "./admin";
import base from "./base";

const validate = {
    admin,
    base,
};

export default validate;
